import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 宋干节活动主页接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132040285
export const songkran_homepage = createAsyncThunk(
  'live/activity/songkran_gender_homepage',
  async (p: any, store: any) => {
    const resp = await http.post('live/activity/songkran_gender_homepage', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data?.data
  }
)

const initialState: {
  home_page_info?: {
    stage_id?: number
    not_having_sex?: boolean
    job_list?: {
      job_id: number
      job_name: string
      job_icon: string
      job_type: number
      job_status: number
      job_need: number
      job_dones: number
      job_done_times: number
      job_max_times: number
      reward_list: [][]
      jump_type: number
      jump_url: string
    }[] // 任务列表
    user_info?: {
      tickets: number // （用户票数）
      rank_type: number // （1男神榜 2女神榜）
      user_info?: {
        member: {
          avatar: string
          mid: number
          name: string
        }
        rank_no: number
        score: number
      }
    }
    countdown?: number
    current_tab?: number
  }
} = {
  home_page_info: {},
}

export const YearVoteSongkranSlice = createSlice({
  name: 'YearVoteSongkran',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(songkran_homepage.fulfilled, (state, action) => {
      Object.assign(state?.home_page_info, action.payload)
    })
  },
})

export default YearVoteSongkranSlice.reducer
export const YearVoteSongkranSliceActions = YearVoteSongkranSlice.actions
